import React from 'react';
import { Row } from 'react-bootstrap';
import {
  buildWhereForDates,
  FormCol,
  FormFilterCard,
  FieldInput,
  FieldDateRanger,
  FieldSelectIsActive,
  TableEditButtons,
  FormCol3,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import {
  FieldSelectCollector,
  FieldSelectGroup,
  FieldSelectMaterialGroup,
  FieldSelectSubregion,
  FieldSelectWasteDestinationType,
  FieldSelectWasteOriginType,
  FieldSelectWasteReceptionPoint,
  FormFieldMultiMaterialDlg,
} from 'shared-pages';
import { AppStore } from 'shared-pages/store/app-store';
import { useRootStore } from 'store';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ identificationDocument: likeObj }],
      };
    }
    if (values.startDate || values.endDate) {
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
    // Δημιουργία ή αλλαγή εγγραφής εντός διαστήματος
    if (values.createdOrChangedStartDate || values.createdOrChangedEndDate) {
      const firstDate = buildWhereForDates(
        values.createdOrChangedStartDate,
        values.createdOrChangedEndDate,
        'firstDate',
      );
      const lastDate = buildWhereForDates(
        values.createdOrChangedStartDate,
        values.createdOrChangedEndDate,
        'lastDate',
      );
      where = {
        ...where,
        $and: {
          $or: [firstDate, lastDate],
        },
      };
    }

    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.subregionId) {
      where = { ...where, subregionId: values.subregionId };
    }
    if (values.regionId) {
      where = { ...where, regionId: values.regionId };
    }
    //this is for the tab filtering
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    }
    if (values.wasteOriginTypeId) {
      where = { ...where, wasteOriginTypeId: values.wasteOriginTypeId };
    }

    if (values.wasteDestinationTypeId) {
      where = { ...where, wasteDestinationTypeId: values.wasteDestinationTypeId };
    }
    if (values.collectorId) {
      where = { ...where, collectorId: values.collectorId };
    }
    if (values.wastereceptionpointId) {
      where = { ...where, wastereceptionpointId: values.wastereceptionpointId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  //
  const { appStore } = useRootStore();
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    startDate: initialValues?.startDate ?? null,
    endDate: initialValues?.endDate ?? null,
    createdOrChangedStartDate: initialValues?.createdOrChangedStartDate ?? null,
    createdOrChangedEndDate: initialValues?.createdOrChangedEndDate ?? null,
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    regionId: initialValues?.regionId ?? undefined,
    subregionId: initialValues?.subregionId ?? undefined,
    wasteOriginTypeId: initialValues?.wasteOriginTypeId ?? undefined,
    wasteDestinationTypeId: initialValues?.wasteDestinationTypeId ?? undefined,
    collectorId: initialValues?.collectorId ?? undefined,
    wastereceptionpointId: initialValues?.wastereceptionpointId ?? undefined,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Κωδ. Εντύπου )')}
          type="search"
          disable={disable}
        />
        {appStore.isPlatformOwner && (
          <FieldSelectCollector as={FormCol} name="collectorId" label={t('Συλλέκτης')} />
        )}

        <FieldSelectWasteOriginType as={FormCol} name="wasteOriginTypeId" defaultValues={filters} />
        <FieldSelectWasteDestinationType
          as={FormCol}
          name="wasteDestinationTypeId"
          defaultValues={filters}
        />
      </Row>
      <Row>
        {/* <FieldSelectRegion as={FormCol} /> */}
        <FieldSelectSubregion as={FormCol} />
        <FieldDateRanger
          as={FormCol}
          label={t('Ημ/νία Συλλογής από')}
          label2={t('Έως')}
          name="startDate"
          name2="endDate"
        />
        <FieldDateRanger
          as={FormCol}
          label="Δημιουργία ή Αλλαγή από"
          name="createdOrChangedStartDate"
          name2="createdOrChangedEndDate"
        />
        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} disable={disable} />
        <FieldSelectWasteReceptionPoint
          as={FormCol}
          name="wastereceptionpointId"
          defaultValues={filters}
        />
      </Row>
    </FormFilterCard>
  );
};
